import {controller, target} from '@github/catalyst'

@controller('text-suggester')
class TextSuggesterElement extends HTMLElement {
  @target declare input: HTMLInputElement
  @target declare suggestionContainer: HTMLElement
  @target declare suggestion: HTMLElement

  acceptSuggestion() {
    if (this.suggestion?.textContent) {
      this.input.value = this.suggestion.textContent
      this.input.dispatchEvent(new Event('input'))
      if (this.suggestionContainer) this.suggestionContainer.hidden = true
      this.input.focus()
    }
  }
}
